const MOCK_CONVERSATIONS = {
  total_conversations: 5,
  conversations: [
    {
      conversation_id: 1042,
      conversation_uuid: "8059df24-2599-4cd6-b702-ee2c35625951",
      created_at: "2025-06-20T16:27:04.006414",
      test: false,
      handed_off: true,
      last_message_time: "2025-07-07T14:55:24.256147",
      summary:
        "Summary: The user greeted the chatbot but did not provide a clear question or request for assistance.\n\nFollow-up action: A customer success agent should reach out proactively to the user to ask if they need any specific help or have questions about Company 3's services.",
      resolved: false,
      customer: {
        picture_url: null,
        created_at: "2025-06-20T16:27:04.002151",
        country: "Unknown Country",
        updated_at: "2025-06-23T13:10:40.890483",
        first_name: "Navy",
        state: "Unknown Region",
        id: 1052,
        city: "Unknown City",
        last_name: "Chameleon",
        external_user_id: null,
        email: "test@gmail.com",
        external_user_created_at: null,
        phone: null,
        company_id: 215,
        url: "http://localhost:3000/setup/chatbot",
        address_id: null,
      },
      intents: [],
      chat_inputs: [
        "2025-06-20T16:27:05.571872",
        "2025-06-23T13:09:35.566820",
        "2025-06-23T13:10:05.376444",
        "2025-06-23T13:10:28.007773",
        "2025-06-23T13:11:01.037564",
        "2025-06-23T13:12:27.287215",
        "2025-06-23T13:13:54.378734",
      ],
      chat_responses: [
        "2025-06-20T16:27:04.016417",
        "2025-06-20T16:27:08.518827",
        "2025-06-20T16:30:19.957568",
        "2025-06-23T12:59:24.544912",
        "2025-06-23T13:08:37.769718",
        "2025-06-23T13:09:41.379997",
        "2025-06-23T13:10:09.238976",
        "2025-06-23T13:10:31.840355",
        "2025-06-23T13:10:40.852292",
        "2025-06-23T13:10:53.967137",
        "2025-06-23T13:12:18.214318",
        "2025-06-23T13:13:42.393496",
        "2025-07-07T11:23:35.887360",
      ],
      resolved_by: 177,
      resolver: {
        first_name: "John",
        id: 177,
        email: "pvlptl2@gmail.com",
        created_at: "2025-03-28T20:55:44.623844",
        last_login_at: "2025-07-07T17:50:14.751068",
        active: true,
        role: null,
        last_name: "Page",
        company_id: 215,
        updated_at: "2025-07-07T15:50:14.751478",
        _picture_url: null,
        title: null,
        supabase_id: "46967586-b73b-4945-8c7d-9c614bcca4af",
        onboard_steps: null,
      },
    },
    {
      conversation_id: 999,
      conversation_uuid: "bcd17b53-b176-495c-95fa-c8ddca53589a",
      created_at: "2025-04-29T14:21:59.027801",
      test: false,
      handed_off: true,
      last_message_time: "2025-07-07T14:55:21.737038",
      summary:
        "Summary: The chatbot greeted the user and inquired if further assistance was needed.\n\nFollow-up action: Customer success agent should reach out to ensure the user’s issue was resolved or offer additional support.",
      resolved: false,
      customer: {
        picture_url: null,
        created_at: "2025-04-29T14:21:59.026476",
        country: "Unknown Country",
        updated_at: "2025-04-29T14:21:59.026481",
        first_name: "Pearl",
        state: "Unknown Region",
        id: 1009,
        city: "Unknown City",
        last_name: "Wolf",
        external_user_id: null,
        email: null,
        external_user_created_at: null,
        phone: null,
        company_id: 215,
        url: "http://localhost:3000/setup/chatbot",
        address_id: null,
      },
      intents: [],
      chat_inputs: ["2025-04-29T14:24:18.739508"],
      chat_responses: [
        "2025-04-29T14:22:32.302825",
        "2025-04-29T14:24:53.185261",
        "2025-04-29T14:21:59.031463",
        "2025-04-29T14:24:21.861944",
        "2025-04-29T14:24:23.154833",
        "2025-07-07T11:35:04.188651",
      ],
      resolved_by: 177,
      resolver: {
        first_name: "John",
        id: 177,
        email: "pvlptl2@gmail.com",
        created_at: "2025-03-28T20:55:44.623844",
        last_login_at: "2025-07-07T17:50:14.751068",
        active: true,
        role: null,
        last_name: "Page",
        company_id: 215,
        updated_at: "2025-07-07T15:50:14.751478",
        _picture_url: null,
        title: null,
        supabase_id: "46967586-b73b-4945-8c7d-9c614bcca4af",
        onboard_steps: null,
      },
    },
    {
      conversation_id: 998,
      conversation_uuid: "000692d6-dad5-4f21-874a-81370f8032f2",
      created_at: "2025-04-29T13:23:55.793856",
      test: false,
      handed_off: true,
      last_message_time: "2025-07-07T14:55:19.381733",
      summary:
        "Summary: The user appears to be testing the chat function without requesting specific assistance.  \nFollow-up action: Reach out to the user to confirm if they need any help or information about services.",
      resolved: false,
      customer: {
        picture_url: null,
        created_at: "2025-04-29T13:23:55.792200",
        country: "Unknown Country",
        updated_at: "2025-04-29T14:21:41.143716",
        first_name: "Sangria",
        state: "Unknown Region",
        id: 1008,
        city: "Unknown City",
        last_name: "Orca",
        external_user_id: null,
        email: "test123@gmail.com",
        external_user_created_at: null,
        phone: null,
        company_id: 215,
        url: "http://localhost:3000/setup/chatbot",
        address_id: null,
      },
      intents: [],
      chat_inputs: [
        "2025-04-29T13:23:58.314031",
        "2025-04-29T14:21:24.693114",
        "2025-04-29T14:21:45.994486",
      ],
      chat_responses: [
        "2025-04-29T13:23:55.799409",
        "2025-04-29T13:24:32.391722",
        "2025-04-29T13:24:02.348134",
        "2025-04-29T14:21:29.508490",
        "2025-04-29T14:21:30.718738",
        "2025-04-29T14:21:41.154176",
        "2025-04-29T14:21:45.994593",
        "2025-07-07T11:35:07.110908",
      ],
      resolved_by: 177,
      resolver: {
        first_name: "John",
        id: 177,
        email: "pvlptl2@gmail.com",
        created_at: "2025-03-28T20:55:44.623844",
        last_login_at: "2025-07-07T17:50:14.751068",
        active: true,
        role: null,
        last_name: "Page",
        company_id: 215,
        updated_at: "2025-07-07T15:50:14.751478",
        _picture_url: null,
        title: null,
        supabase_id: "46967586-b73b-4945-8c7d-9c614bcca4af",
        onboard_steps: null,
      },
    },
    {
      conversation_id: 991,
      conversation_uuid: "8f865f31-3d17-4e43-be13-b590f0c39541",
      created_at: "2025-04-24T14:21:40.916032",
      test: false,
      handed_off: true,
      last_message_time: "2025-07-07T14:55:17.537994",
      summary:
        "Summary: The user requested customer support and the chatbot asked for more details about the issue.\n\nFollow-up action: Contact the user to provide personalized assistance based on the specific issue they describe.",
      resolved: false,
      customer: {
        picture_url: null,
        created_at: "2025-04-24T14:21:40.908177",
        country: "Unknown Country",
        updated_at: "2025-04-25T12:21:18.926322",
        first_name: "Ash",
        state: "Unknown Region",
        id: 1001,
        city: "Unknown City",
        last_name: "Gray Camel",
        external_user_id: null,
        email: "test@gmail.com",
        external_user_created_at: null,
        phone: null,
        company_id: 215,
        url: "http://localhost:3000/setup/chatbot",
        address_id: null,
      },
      intents: [],
      chat_inputs: [
        "2025-04-29T13:15:25.147078",
        "2025-04-25T11:19:01.379913",
        "2025-04-25T11:19:11.703012",
      ],
      chat_responses: [
        "2025-04-24T14:21:40.921439",
        "2025-04-24T14:22:10.971105",
        "2025-04-25T11:19:05.017320",
        "2025-04-25T11:19:13.930182",
        "2025-04-25T11:19:15.047928",
        "2025-04-25T11:19:45.109545",
        "2025-04-25T12:21:18.937272",
        "2025-04-25T12:21:55.931713",
        "2025-04-29T13:15:25.147260",
        "2025-07-07T11:54:26.599928",
      ],
      resolved_by: 177,
      resolver: {
        first_name: "John",
        id: 177,
        email: "pvlptl2@gmail.com",
        created_at: "2025-03-28T20:55:44.623844",
        last_login_at: "2025-07-07T17:50:14.751068",
        active: true,
        role: null,
        last_name: "Page",
        company_id: 215,
        updated_at: "2025-07-07T15:50:14.751478",
        _picture_url: null,
        title: null,
        supabase_id: "46967586-b73b-4945-8c7d-9c614bcca4af",
        onboard_steps: null,
      },
    },
    {
      conversation_id: 990,
      conversation_uuid: "31a50ddb-48fa-47bd-bfdb-72398630e358",
      created_at: "2025-04-24T14:02:38.540214",
      test: false,
      handed_off: true,
      last_message_time: "2025-07-07T14:55:15.102165",
      summary:
        "Customer did not provide any input beyond the chatbot's introductory messages; no specific assistance was requested.\n\nFollow-up action: Reach out to the customer proactively to inquire if they need any help or have questions.",
      resolved: false,
      customer: {
        picture_url: null,
        created_at: "2025-04-24T14:02:38.537632",
        country: "Unknown Country",
        updated_at: "2025-04-24T14:02:38.537642",
        first_name: "Tan",
        state: "Unknown Region",
        id: 1000,
        city: "Unknown City",
        last_name: "Viper",
        external_user_id: null,
        email: null,
        external_user_created_at: null,
        phone: null,
        company_id: 215,
        url: "http://localhost:3000/setup/chatbot",
        address_id: null,
      },
      intents: [],
      chat_inputs: ["2025-04-24T14:04:56.453900"],
      chat_responses: [
        "2025-04-24T14:02:38.546624",
        "2025-04-24T14:03:24.531210",
        "2025-04-24T14:05:01.094209",
        "2025-04-24T14:05:36.181072",
        "2025-07-07T11:55:10.475956",
      ],
      resolved_by: 177,
      resolver: {
        first_name: "John",
        id: 177,
        email: "pvlptl2@gmail.com",
        created_at: "2025-03-28T20:55:44.623844",
        last_login_at: "2025-07-07T17:50:14.751068",
        active: true,
        role: null,
        last_name: "Page",
        company_id: 215,
        updated_at: "2025-07-07T15:50:14.751478",
        _picture_url: null,
        title: null,
        supabase_id: "46967586-b73b-4945-8c7d-9c614bcca4af",
        onboard_steps: null,
      },
    },
  ],
};

export default MOCK_CONVERSATIONS;
